// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"zR-z","categoryName":"AR-z","categoryNameSearchHeader":"BR-z","categoryContent":"CR-z","bottomAligned":"DR-z","image":"ER-z","imageNoBackground":"FR-z"};